import { MouseEvent, PropsWithChildren } from 'react'
import { Link } from '@vp/swan'
import { LinkWithQueryProps } from '~/client/components/common/LinkWithQuery/interface'
import { useDispatch } from 'react-redux'
import { useGalleryUrl } from '~/client/hooks/useGalleryUrl'
import { useSearchParams } from '~/client/hooks/useSearchParams'
import { setQuickViewId } from '~/client/store/debug/actions'
import { ThunkDispatch } from '~/client/store/interface'

export const LinkWithQuery = ({ children, designId, currentDesignId, onClick, noFollow, className, fullUrl }: PropsWithChildren<LinkWithQueryProps>) => {
  const dispatch = useDispatch<ThunkDispatch>()
  const url = useGalleryUrl()
  const searchParams = useSearchParams()

  if (!fullUrl) {
    searchParams.forEach((value, key) => {
      url.searchParams.set(key, value)
    })

    url.searchParams.set('qv', designId)
  }

  const handleClick = (event: MouseEvent<HTMLAnchorElement>): void => {
    event.preventDefault()
    onClick?.()
    if (fullUrl) {
      return
    }
    dispatch(setQuickViewId(designId))

    // This hack appeared after migration from `react-router-dom` in order to set `designId` to `window.history.state`. It doesn't do anything else.
    window.history.replaceState({ ...window.history.state, designId: currentDesignId, usr: { designId: currentDesignId } }, '')
  }

  return (
    <Link
      onClick={handleClick}
      href={fullUrl ? fullUrl : url.toString()}
      rel={noFollow ? 'nofollow' : undefined}
      style={{ display: 'inherit' }}
      className={className}
    >
      {children}
    </Link>
  )
}
